


















































































































































































import { Prop, Component, Vue, Watch } from 'vue-property-decorator';
import { BrandingInterface } from '../../../common-vue-components';
import SeverityIcon from '../SeverityIcon/SeverityIcon.vue';
import {DEFAULT_SEVERITIES} from '../SeverityIcon/SeverityModel';
import SeverityInterface from '../SeverityIcon/SeverityInterface';
import BadgeMenuNotification from '../BadgeMenuNotification.vue';

@Component({
    name: 'MoreMenu',
    components: {
        SeverityIcon,
        BadgeMenuNotification,
    },
})
export default class MoreMenu extends Vue {
    @Prop(Object)
    public readonly branding?: BrandingInterface;
    /**
     * Route to go to when about menu clicked.  If undefined, no about menu item shown.
     */
    @Prop([Object, String])
    public readonly aboutRoute?: { name: string; param?: object } | string;
    /**
     * Stornext external link
     */
    @Prop(Object)
    public readonly stornextLink?: {};
    /**
     * Array of notifications to display in more menu
     */
    @Prop(Object)
    public notifications?: any;

    @Prop({default: false, type: Boolean})
    public readonly theme?: boolean;

    @Prop([Function, Boolean])
    public readonly themeChangeFxn?: (val: boolean) => void | undefined;

    @Prop(String)
    public readonly externalHelp?: string;

    @Prop(String)
    public readonly corplink?: string;

    @Prop({default: true, type: Boolean})
    public readonly corplinkInNewTab?: boolean;

    @Prop(String)
    public readonly support?: string;

    @Prop(String)
    public readonly feedback?: string;

    @Prop({ default: false, type: Boolean })
    public readonly showFeedbackInModal?: boolean;

    @Prop({default: true, type: Boolean})
    public readonly supportInNewTab?: boolean;

    @Prop(Function)
    public readonly tooltipChangeFxn?: (val: boolean) => void | undefined;

    @Prop({default: false, type: Boolean})
    public readonly showToolTips?: boolean;

    @Prop(Array)
    public readonly moreMenuItems?: [];

    public readonly severities: SeverityInterface = DEFAULT_SEVERITIES;
    public menu: boolean = false;
    public message: boolean = false;
    public hints: boolean = true;
    public closeOnClick: boolean = false;
    public more_menu_key: string = 'key';

    @Watch('$route')
    public onChangeRoute(to: any, from: any) {
        setTimeout(() => {
            this.closeOnClick = false;
        });
    }

    public closeMenu(): void {
        this.closeOnClick = true;
    }

    public settingsNot() {
        let count: number = 0;
        const highestSeverityNot: any = {weight: 0, color: '#d12021'};
        for (const property in this.notifications) {
            if (this.notifications.hasOwnProperty(property)) {
                if (
                    !!this.notifications[property].text ||
                    !!this.notifications[property].severity
                ) {
                    if (!highestSeverityNot.severity && !highestSeverityNot.text) {
                        if (!!this.notifications[property].severity) {
                            highestSeverityNot.severity = this.notifications[property].severity;
                            highestSeverityNot.weight = this.severities[this.notifications[property].severity].weight;
                        } else if (!!this.notifications[property].text) {
                            highestSeverityNot.text = this.notifications[property].text;
                            highestSeverityNot.color = this.notifications[property].color;
                            highestSeverityNot.weight = 0;
                        }
                    } else if (highestSeverityNot.severity || highestSeverityNot.text) {
                        if (
                            !!this.notifications[property].severity && this.severities[this.notifications[property].severity].weight >
                            highestSeverityNot.weight
                        ) {
                            highestSeverityNot.severity = this.notifications[property].severity;
                            highestSeverityNot.weight = this.severities[this.notifications[property].severity].weight;
                        } else if (!!this.notifications[property].text) {
                            // HighestSeverityNot.text = this.notifications[property].text
                            // HighestSeverityNot.color = this.notifications[property].color
                            // HighestSeverityNot.weight = 0;
                        }
                    }
                    count++;
                    if (
                        this.notifications[property].severity &&
                        this.severities[this.notifications[property].severity].weight >
                        highestSeverityNot.weight
                    ) {
                        highestSeverityNot.weight = this.severities[this.notifications[property].severity].weight;
                    }
                }
                // If there is more than one notification, display the count and use the highest severity color
                if (count > 1) {
                    // Change the general color to the severity color if the highest notification is a severity icon
                    if (highestSeverityNot.severity) {
                        highestSeverityNot.color = this.severities[highestSeverityNot.severity].color;
                    }
                    highestSeverityNot.text = count.toString();
                    highestSeverityNot.tooltip = 'multiple notifications';
                }
            }
        }
        if (count === 1) {
            // Change the settings text to 1 if only 1 text alert
            if (highestSeverityNot.text) {
                highestSeverityNot.text = '1';
            }
        }
        return highestSeverityNot;
    }

    public get logoMini(): string {
        const themePath: string = this.$vuetify.theme.dark ? 'dark' : 'light';
        const baseLogoMini = require('../../../public/static/themes/' +
            themePath +
            '/quantum/images/logo-mini.png');
        const logoMini: string =
            (this.branding && this.branding.logoMini) || baseLogoMini;
        return logoMini;
    }

    public broadcast(item: string) {
        const e = item;
        this.$emit(e.toLowerCase());
        if (this.notifications && this.notifications[item]) {
            this.notifications[item] = {};
        }
        setTimeout(() => {
            this.more_menu_key += 'y';
            this.closeOnClick = false;
        }, 1000);
    }

    public goToFeedback(feedbackLink: string) {
        this.closeMenu();

        if (!this.showFeedbackInModal) {
            if (feedbackLink) {
                this.$router.push(feedbackLink);
            }
        } else {
            this.broadcast('feedback');
        }
    }
}
/* More Menu Notifications JSON format is as follows
    MORE_MENU_NOTIFICATIONS:{
        about: {
            text:'1',
            color:'#FF0000',
            tooltip:'New specifications on hardware available',
        },
        help: {
            severity:'alert',
            tooltip:'New specifications on hardware available',
        },
        support: {
            text:'words',
            color:'#FF0000',
            tooltip:'New specifications on hardware available',
        },
    }
*/
